import React from "react";
import "./_NecklaceSelector.scss";
import Necklace from "../Necklace/Necklace";
import MemorySelectButton from "../MemorySelectButton/MemorySelectButton";
import { connect } from "react-redux";
import { toggleNecklaceSelectModal } from "../../redux/actions";

class NecklaceSelector extends React.Component {
  renderMemories = (min, max) => {
    const { activeMemories } = this.props;
    const memories = [];
    for (let i = min; i <= max; i++) {
      const rightButton = i > 7;
      if (i === 1) {
        /**
         * First item must be always active:
         */
        memories.push(
          <MemorySelectButton
            number={i}
            disabled={false}
            key={i}
            memory={activeMemories[i - 1]}
            rightButton={rightButton}
          />
        );
      } else {
        // i >= 2
        if (activeMemories.length >= i - 1) {
          /**
           * If active memory is not null, then it must be active.
           */
          memories.push(
            <MemorySelectButton
              number={i}
              disabled={false}
              key={i}
              memory={activeMemories[i - 1]}
              rightButton={rightButton}
            />
          );
        } else {
          memories.push(
            <MemorySelectButton
              number={i}
              disabled={true}
              key={i}
              memory={activeMemories[i - 1]}
              rightButton={rightButton}
            />
          );
        }
      }
    }
    return memories;
  };

  render() {
    return (
      <div className="necklace-selector">
        <div className="necklace-selector-list">
          {this.renderMemories(1, 7)}
        </div>
        <Necklace />
        <div className="necklace-selector-list">
          {this.renderMemories(8, 14)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ necklace }) => {
  const { activeMemories } = necklace;

  return {
    activeMemories,
  };
};

export default connect(mapStateToProps, { toggleNecklaceSelectModal })(
  NecklaceSelector
);
